<template>
  <vue-seamless-scroll
    ref="seamlessScroll"
    :data="images"
    :class-option="classOption"
    :class="['rolling-picture-bar', isMobile && 'rolling-picture-bar-mobile']"
  >
    <div class="ul-item">
      <img
        v-for="(item, index) in images"
        :key="index"
        :src="item"
        alt="image"
        :height="isMobile ? 200 : 260"
        @load="onImgLoaded(index)"
      >
    </div>
  </vue-seamless-scroll>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
    name: 'RollingPictureBar',
    components: {
        vueSeamlessScroll,
    },
    props: {
        images: {
            type: Array,
            default: () => [],
        },
    },
    data () {
        return {
        };
    },
    computed: {
        classOption () {
            return {
                hoverStop: true,
                direction: 2,
                autoPlay: true,
                limitMoveNum: this.images.length,
            };
        },
        docmentHidden () {
            return this.$store.getters['system/getDocmentHidden'];
        },
        isMobile () {
            return (/Mobi|Android|iPhone/i.test(navigator.userAgent));
        },
    },
    watch: {
        docmentHidden (val) {
            if (val) {
                this.$refs.seamlessScroll._stopMove();
            } else {
                this.$refs.seamlessScroll._startMove();
            }
        },
    },
    mounted () {
    },
    methods: {
        onImgLoaded (index) {
            if (index >= this.images.length - 1) {
                setTimeout(() => {
                    this.$refs.seamlessScroll.reset();
                }, 200);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.rolling-picture-bar {
    width: 100vw;
    height: 270px;
    overflow: hidden;
    &.rolling-picture-bar-mobile {
        height: 210px;
        .ul-item {
            height: 210px;
        }
    }
    .ul-item {
        display: flex;
        height: 270px;
        >img{
            display: block;
            margin: 0 20px;
            box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
        }
    }
}
</style>
